import {
  InputRightElement,
  type InputRightElementProps
} from '@chakra-ui/react';

export type UiInputRightElementProps = InputRightElementProps;

export const UiInputRightElement = InputRightElement;
